import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import SubProjectIncomeRecordWidget from '../../../widgets/subProjectIncomeRecordWidgets/SubProjectIncomeRecordWidget'
import { getSubProjectIncomeRecord } from '../../../redux/actions/subProjectIncomeRecord'
import { sessionGetItemObj, sessionGetItemStr } from '../../../utils/sessionHelpers'

export default function SubProjectIncomeRecord() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const subProjectCode = sessionGetItemStr('subProjectCode')
  const { periodNo } = sessionGetItemObj('subProjectPeriodInfo')
  const subIncomeId = sessionGetItemStr('subIncomeId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getSubProjectIncomeRecord(subProjectCode, periodNo, subIncomeId)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeAndExpense>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton />

        <SubProjectIncomeRecordWidget schema={schema} />
        <br />
      </SidebarProposal>
    </div>
  )
}

// const mockSchema = {
//   affectedRows: 5,
//   message: 'Successfully',
//   success: true,
//   didError: false,
//   errorMessage: null,
//   model: {
//     header: 'บันทึกรับโครงการย่อย',
//     subHeader: '',
//     disabled: false,
//     projectInfo: {
//       projectCode: '64-00867',
//       projectName: 'โครงการทดสอบ',
//       duration: '1/ม.ค./2564 - 31/ม.ค./2565', // ระยะเวลาดำเนินงาน
//       countOfSubProject: '11', // มีโครงการย่อย
//       isPurchaseOfDurableGoods: 'มี', //จัดซื้อครุภัณฑ์ มี,ไม่ระบุ
//       contractNo: '64-00-0596',
//       coordinator: 'ชลการ นักประสาน (สำนัก 6)',
//       responsibler: 'สมชาย เก่งกาจ', // ผู้รับผิดชอบโครงการ
//       projectStatus: 'ดำเนินการ',
//       subProjectName: 'ตัวอย่างโครงการย่อย',
//       subPjectCode: '64-00867-1T',
//       department: '1',
//     },
//     form: {
//       periodOption: {
//         label: 'เลือกงวดโครงการ',
//         name: 'periodOption',
//         value: '1',
//         options: [
//           {
//             disabled: false,
//             label: 'งวดที่ 1 (dd/mm/yyyy - dd/mm/yyyy)',
//             value: '1',
//           },
//         ],
//         validators: [{ type: 'REQUIRED', value: null, errorMessage: 'เลือกงวดโครงการ' }],
//       },
//       period: {
//         label: 'งวดที่',
//         value: '1 / 3',
//       },
//       voucherNumber: {
//         label: 'เลขที่ใบสำคัญ',
//         name: 'voucherNumber',
//         value: '',
//         validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกเลขที่ใบสำคัญ' }],
//       },
//       referenceNumber: {
//         label: 'เลขที่เอกสารอ้างอิง',
//         name: 'referenceNumber',
//         value: '',
//       },
//       voucherDate: {
//         label: 'วันที่เอกสาร',
//         name: 'voucherDate',
//         value: '',
//         validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกวันที่เอกสาร' }],
//       },
//       attachFiles: {
//         name: 'attachFiles',
//         label: 'เอกสารแนบประกอบ',
//         value: [],
//         id: null,
//         validators: [],
//       },
//       formTable: {
//         total: 0,
//         expenseList: {
//           label: 'รายการ',
//           name: 'expenseList',
//           value: '',
//         },
//         expenseTotal: {
//           label: 'ยอดรวม',
//           name: 'expenseTotal',
//           value: '',
//         },
//         values: [
//           {
//             id: '90',
//             expenseList: 'รับเงินจากโครงการหลัก',
//             expenseTotal: 26000,
//             isDeletable: false,
//           },
//           {
//             id: '91',
//             expenseList: 'รับคืนค่าจัดกิจกรรม',
//             expenseTotal: 47000,
//             isDeletable: false,
//           },
//           {
//             id: '',
//             expenseList: 'รวมทั้งสิ้น',
//             expenseTotal: 73000,
//             isSummary: true,
//           },
//         ],
//       },
//     },
//   },
// }
